import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { WOOSMAP_LOADER, WOOSMAP_KEY } from '~/const/3rd';

const StoreAvailabilityModal = () => import(
/* webpackMode: "eager" */
'~/components/molecules/Product/Modal/StoreAvailabilityModal.vue');

export default {
  name: 'StoreAvailability',
  components: {
    StoreAvailabilityModal
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    isSimpleLink: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModal: false,
      modal: null,
      loaded: false
    };
  },

  methods: {
    closeAction() {
      this.showModal = false;
      this.modal = null;
    },

    handleClick(event) {
      var _this = this;

      if (!this.loaded) {
        this.asyncScript(WOOSMAP_LOADER).then(
        /*#__PURE__*/
        _asyncToGenerator(function* () {
          const loaderOptions = {
            version: '1.4',
            publicKey: WOOSMAP_KEY
          };
          window.WoosmapLoader.load(loaderOptions);
          _this.loaded = true;
        })).catch(err => {
          console.error(err);
        });
      }

      this.modal = 'store-availability-modal';
      this.showModal = true;
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_Dispo_mag',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }

  }
};